import theme from '@keyslabor/shared/theme';
import { PropsWithChildren } from 'react';

export type WithChild<T = unknown> = PropsWithChildren<T>;

export type Theme = typeof theme;

export enum Routes {
  ManagerRoot = '/manager/',
  RequestEmployeeList = '/manager/employee/request-employee/',
  Login = '/manager/login',
  EmployeeCreate = '/manager/employee/create/',
  EmployeeList = '/manager/employee/list/',
  Tracking = '/manager/employee/tracking/list/',
  TrackingByDay = '/manager/employee/tracking/by_day/',
  InvoiceList = '/manager/invoice/list/',
  InvoiceCreate = '/manager/invoice/create/',
  LostHoursList = '/manager/lost_hours/list/',
  ScheduleList = '/manager/schedule/list/',
  PasswordChange = '/manager/change_password/',
  PropertySelection = '/manager/property/selection/',
  LeadsInhouse = '/manager/leads/inhouse/',
  LeadsByAgency = '/manager/leads/by-agency/',
  OpenPositions = '/manager/company/open-positions/',
  LogOut = '/manager/logout/',
  TurnOver = '/manager/tips/list',
  ShiftDay = '/shift-day/',
  ReviewReport = '/review-report/',
  Billing = '/manager/billing/',
}

export type BreakpointsProp = Array<string> & {
  sm?: string;
  md?: string;
  lg?: string;
  xl?: string;
};

export interface Position {
  id: number;
  name: string;
  priority?: number;
}

export interface AjaxPosition {
  value: string;
  label: string;
}

export type Shift = [number, string];

export interface Employee {
  id: number;
  name: string;
  names: {
    first_name: string;
    last_name: string;
  };
  name_nice: string;
  phone: string;
  photo_thumbnail: string;
  photo_thumbnail_large_size: string;
  wd: true;
}

export interface Tracking {
  employee: Employee;
  working_hours: WorkingHour[];
  regular: string;
  overtime: string;
  is_empty_week_invoiced: boolean;
}
interface CreatedBy {
  id: number;
  name: string;
}

interface ClockInOut {
  id: number;
  employee: Employee;
  similarity: number;
  has_mobile_photo: boolean;
  photo_thumbnail: string;
  photo_thumbnail_large_size: string;
  no_photo_thumbnail_large_size: string;
  created_by?: CreatedBy;
  lat: unknown;
  lon: unknown;
  mobile: boolean;
  no_similarity_check: boolean;
  report: unknown;
}

interface ClockIn extends ClockInOut {
  auto_clockin: boolean;
  manual_auto_clockin: boolean;
}

interface ClockOut extends ClockInOut {
  auto_clockout: boolean;
  manual_auto_clockout: boolean;
}

export interface WorkingHour {
  id: number;
  clock_in_at: string;
  clock_out_at: string;
  clock_in: ClockIn;
  clock_out: ClockOut;
  clock_in_edited_by: CreatedBy;
  clock_out_edited_by: CreatedBy;
  hours: number;
  minutes: number;
  total_seconds: number;
  punch_date: string;
  autoclockout: boolean;
  autoclockin: boolean;
  deleted: boolean;
  employee: Employee;
  created_by: CreatedBy;
  edited_by: CreatedBy;
  invoiced: boolean;
  report: CreatedBy;
  is_full_day: boolean;
  mobile_clock: boolean;
}

export interface Employment {
  id: number;
  code: string;
  employee: Employee;
  created_by: unknown;
  online: boolean;
  last_online: unknown;
  employee_rate: string;
  position: Position;
  error: boolean;
  is_blocked: boolean;
  blocked_by: unknown;
  hours: string;
  uniform_request: unknown;
  mobile: boolean;
  repeat: boolean;
  first_day?: boolean;
  is_check_pending: boolean;
  description: string;
}

export interface SelectOption {
  label: string;
  value: number | string;
}

export interface Coords {
  lat: number;
  lng: number;
}

export enum RestrictionMessages {
  RestrictInvoiceSend = "You don't have permission to approve and send invoices.",
  RestrictAddFullDay = "You can't add a full day for blocked employees",
  RestrictBlockEmployees = 'The blocked employees cannot be clocked in.',
}

export interface Option {
  value: number | string;
  label: string;
}
